module.exports = __webpack_public_path__ + "img/L_1D.772ea4fb.png";